import { apiClient } from "../apiClient";
export const KE_HOACH_NAM_ENDPOINT = "ke-hoach-nam";
export const keHoachNamApi = {
  SelectAll: () => apiClient.get(`${KE_HOACH_NAM_ENDPOINT}`),
};
